import { DATATYPE } from "core/metamodel/mdField";
import { CONFIGLEVEL } from "core/metamodel/metaConstant";
import {
    yellow200,
    orange200,
    deepOrange300,
    blueGrey200,
    blueGrey400,
    lightBlue400,
    cyan400,
    cyan200,
    lightBlue200,
    yellow400,
    orange400,
    deepOrange500,
    orange500,
    yellow500,
    cyan100,
    lightBlue100,
    blueGrey100
  } from "material-ui/styles/colors";
import {LovItem} from "../../metamodel/mdEntity";

export const COLORS: string[] = [
  orange400,
  deepOrange500,
  yellow500,
  lightBlue400,
  orange200,
  deepOrange300,
  blueGrey200,
  blueGrey400,
  cyan400,
  cyan200,
  lightBlue200,
  yellow400,
  orange500,
  cyan100,
  lightBlue100,
  blueGrey100
]

export interface DataSeries {
  id: string;
  name: string
  enable: boolean, //is used in chart -> is checked
  type?: ChartType //To be used in future
  color?: string,
  isUsedOnGrid: boolean
}

export interface ChartConfigDto {
  chartId: number;
  chartName: string;
  chartType: ChartType;
  chartColumnsIds: string[];
  chartXField?: string;
  chartSorted: boolean;
  configLevel: CONFIGLEVEL;
}

export enum ChartType {
  BAR = "bar",
  LINE = "line",
  AREA = "area"
}

export function seriesTypeToLovItem(st : ChartType) : LovItem<ChartType> {
  return {value : st, label : st} as LovItem<ChartType>
}

export interface PaneChartConfig extends ChartConfigDto {
  isNew?: boolean;
}



// WEBPACK FOOTER //
// ./src/core/components/chart/chartDomain.ts